import {ServiceFacility} from '../../interfaces/core/service-facility';

export class ServiceFacilityFactory {

  /**
   *
   * @param serviceFacility
   */
  public static fromObject(serviceFacility: any): ServiceFacility {
    return {
      id: serviceFacility.id,
      shortName: '',
      longName: serviceFacility.name,
    };
  }

  /**
   *
   * @param serviceFacilities
   */
  public static fromArray(serviceFacilities: any[]): ServiceFacility[] {
    return serviceFacilities.map(_serviceFacility => ServiceFacilityFactory.fromObject(_serviceFacility));
  }
}
